export enum PermissionTypes {
    /* PAETEP */
    PAETEP = "PAETEP",

    /* Buildings */
    PAETEP_BUILDINGS_FOR_ADMIN = 'BLDA',

    // SMUI
    PAETEP_SMUI = "SMUI",
    PAETEP_SMUI_CAN_VIEW_ALL_NON_SUPERVISORS = "SMCVANS",
    PAETEP_SMUI_ADMIN_VIEW = "SMAV",
    PAETEP_SMUI_CAN_VIEW_ALL_SUPERVISORS = "SMCVAS",

    // User Summary
    PAETEP_USER_SUMMARY = "US",
    PAETEP_USER_SUMMARY_CAN_VIEW = "USV",
    PAETEP_USER_SUMMARY_CAN_VIEW_MY_OBSERVATIONS = "USVM",
    PAETEP_USER_SUMMARY_CAN_VIEW_OTHERS_OBSERVATIONS = "USVO",

    // Anecdotal
    PAETEP_ANECTODALS = "ANC",

    // Custom Forms
    PAETEP_CUSTOM_FORMS = "CustomForms",
    PAETEP_CUSTOM_FORMS_BUILDER = "CustomFormsBuilder",
    PAETEP_CFB_CAN_VIEW_DELETED = "CFBCVD",
    PAETEP_CFB_CAN_CREATE = "CFBCC",
    PAETEP_CFB_CAN_CREATE_STANDARD = "CFBCCS",
    PAETEP_CFB_CAN_CREATE_UNIVERSAL_TEMPLATE = "CFBCCUT",
    PAETEP_CFB_CAN_CREATE_SUPPORT_STAFF_TEMPLATE  = "CFBCCSST",

    // Diff
    PAETEP_DIFF = "Differentiated",

    // Formal
    PAETEP_FORMAL = "FM",
    PAETEP_FORMAL_CAN_CREATE = "CFM",
    PAETEP_FORMAL_CAN_BEGIN_SECTION = "BFM",
    PAETEP_FORMAL_CAN_SCHEDULE_SECTION = "SCFM",
    PAETEP_FORMAL_CAN_SKIP_SECTION = "SKFM",
    PAETEP_FORMAL_CAN_RESTORE_SECTION = "RFM",

    // IEP
    PAETEP_IEP = "IEP",

    // NTPE
    PAETEP_NTPE = "NTPE",

    // PPG
    PAETEP_PPG = "PPG",

    // Rating Forms
    PAETEP_RATING_FORMS = "RatingForms",
    PAETEP_RATING_FORMS_EDIT = "RF_001",

    // Rubric
    PAETEP_RUBRIC = "RUBRIC",
    PAETEP_RUBRIC_CAN_CREATE = "RBC",

    // SLO
    PAETEP_SLO = "SLO",

    // SPM
    PAETEP_SPM = "SPM",

    // Walkthroughs
    PAETEP_WALKTHROUGHS = "WLK",

    FILE_ATTACHMENTS = "FA_000",

    /* Administration */
    ADMINISTRATION = "ADM",
    ADMINISTRATION_USER_MANAGEMENT = "UM",
    ADMINISTRATION_USER_MANAGEMENT_BULK_UPDATE = "UMBU",
    ADMINISTRATION_PERMISSIONS  = "PERM",
    ADMINISTRATION_PERMISSIONS_CAN_VIEW_ALL  = "PERMV",
    ADMINISTRATION_PERMISSIONS_CAN_EDIT_ROLES  = "PERMER",
    ASSIGNMENTS_CAN_ASSIGN_TO_BUILDINGS = "ADMBLGASMNT",
    ADMINISTRATION_BUILDINGS = "ADMBLG",
    ADMINISTRATION_BUILDING_ASSIGNMENT = "ADMBLGASMNT",
    ADMINISTRATION_BUILDING_CAN_VIEW_ALL_PORTAL_BUILDINGS = "ADMBLGVAPB",
    ADMINISTRATION_BUILDING_CAN_DELETE = "ADMBLGDLTE",
    PRESET_MANAGEMENT = "ADMPRESET",
    ADMINISTRATION_RATING_FORM_MANAGEMENT = "ADMRATINGMGM",

    /* Reports */
    REPORTING = "RPT",
    REPORTING_COMPONENT = "RPTC",
    REPORTING_OBS_SUMMARY = "RPTOS",
    REPORTING_GROWTH_AND_STRENGTH= "RPTGS",
    REPORTING_EDU_EFFECT_INDIVIDUAL = "RPTEEI",
    REPORTING_EDU_EFFECT_BUILDING = "RPTEEB",

    /* SUPER ADMIN */
    IS_SUPER_ADMIN = "IS_SUPER_ADMIN",

    /* EDIT CONTENT */
    CAN_EDIT_PORTAL_CONTENT = "EDC_000",
    CAN_EDIT_EDL_CONTENT = "EDC_001"

}
